(function () {
  'use strict';

  angular.module('ringbaPortal').directive('trCountryFlag', trCountryFlag);

  function trCountryFlag() {
    const directive = {
      restrict: 'E',
      transclude: true,
      scope: {
        countryCode: '<'
      },
      controller: 'CountryFlagController',
      controllerAs: 'vm',
      bindToController: true,
      templateUrl: '/scripts/shared/directives/country-flag/country-flag.view.html'
    };
    return directive;
  }
})();
